import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, map, of, switchMap } from 'rxjs';
import { Store } from '@ngrx/store';
import { AccountSitesService } from '../../services/account-sites.service';
import { ACCOUNT_SITES_ACTIONS } from '../actions/account-sites.actions';
import { ACCOUNT_SITES_PRODUCTS_ACTIONS } from '../../../feature-modules/admin/pages/sites-dashboard/store/account-sites-products.actions';
import { APPLICATION_FILTERS_REDUCER } from '../reducers/filters.reducer';

@Injectable()
export class AccountSitesEffects {
  constructor(
    private readonly actions: Actions,
    private readonly store: Store,
    private readonly accountSitesService: AccountSitesService,
  ) {}

  refetchSites$ = createEffect(() =>
    this.actions.pipe(
      ofType(
        ACCOUNT_SITES_PRODUCTS_ACTIONS.updateBulkSitesProductsSuccess,
        ACCOUNT_SITES_PRODUCTS_ACTIONS.updateSiteProductsSuccess,
        ACCOUNT_SITES_PRODUCTS_ACTIONS.updateBulkSitesProductsError,
      ),
      map(() => ACCOUNT_SITES_ACTIONS.getAccountSites()),
    ),
  );

  getAccountSites$ = createEffect(() =>
    this.actions.pipe(
      ofType(ACCOUNT_SITES_ACTIONS.getAccountSites),
      switchMap(() => this.store.select(APPLICATION_FILTERS_REDUCER.selectAccountId)),
      filter(Boolean),
      switchMap((accountId) =>
        this.accountSitesService.getAccountSites(accountId).pipe(
          map((sites) => ACCOUNT_SITES_ACTIONS.getAccountSitesSuccess(sites)),
          catchError((err: Error) => of(ACCOUNT_SITES_ACTIONS.getAccountSitesError(err))),
        ),
      ),
    ),
  );
}
